import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "star-button group relative",
  {
    variants: {
      variant: {
        default: "from-magic-purple to-magic-blue hover:from-magic-blue hover:to-magic-purple",
        fun: "from-rainbow-r to-rainbow-o hover:from-rainbow-y hover:to-rainbow-g",
        magic: "from-magic-blue to-magic-green hover:from-magic-green hover:to-magic-yellow",
      },
      size: {
        default: "h-12 px-8",
        lg: "h-14 px-10 text-lg",
        sm: "h-10 px-6 text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants } 